import React, { useContext } from 'react';
import PropTypes from 'prop-types';
// components
import Dashboard from './../../components/Dashboard/Dashboard';
import { DashContext, CommonContext } from './../../contexts/constant/ActionTypes';

const DashboardPage = ({history, match, loginDetails}) => {
    const dashContext = useContext(DashContext);
    const commonContext = useContext(CommonContext);
    
	return (
        <Dashboard 
            history={history} 
            match={match}
            loginDetails={loginDetails}
            dashContext={dashContext}
            commonContext={commonContext}
        />
	);
}

DashboardPage.propTypes = {
    history: PropTypes.instanceOf(Object),
    match: PropTypes.instanceOf(Object)
};

DashboardPage.defaultProps = {
    history: {},
    match: {}
};

export default DashboardPage;



// WEBPACK FOOTER //
// ./containers/DashboardPage/DashboardPage.js